import { Outlet } from 'react-router';
import { ThemeEffect } from '@/app/theme-effect';
import { ModalHost, ToastHost } from '@/lib/ui';

export function RootLayout() {
  return (
    <>
      <ThemeEffect />
      <Outlet />
      <ToastHost />
      <ModalHost />
    </>
  );
}
